var questionType = Object.freeze({
   FILL_IN: 'FITB',
   CHOICE: 'MC',
   SHORT: 'SHORT'
});

export default questionType;
